import { Component, OnInit, Inject } from '@angular/core';
import {MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA} from '@angular/material/legacy-dialog';

@Component({
  selector: 'app-cron-dialog',
  templateUrl: './cron-dialog.component.html',
  styleUrls: ['./cron-dialog.component.scss']
})
export class CronDialogComponent implements OnInit {
  baseWord?: string;

  constructor(
    public dialogRef: MatDialogRef<CronDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  ngOnInit(): void {
    this.baseWord = this.data?.baseWord;
  }

}
